import type {ReactAction} from '@netx/core/bootstrap';
import {appRouter} from '@netx/core-next/instance/router';
import {faChartPie} from '@fortawesome/pro-solid-svg-icons';
import {canViewStats} from '../enablers';
import {StatsLabel} from '../locales';

export const statsActionStatsRouteIcon = faChartPie;

/**
 * Route to stats
 * @param params
 * @returns Action
 */
export const statsActionStatsRoute = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'stats-route',
	cb: () => appRouter.navigate('stat/usage', true),
	enableTest: () => canViewStats(),
	icon: statsActionStatsRouteIcon,
	get label() {
		return StatsLabel.ROUTE;
	},
	routeMatch: /^stat(\/?)/,
	...params,
});
